module.exports = __webpack_public_path__ + "static/media/menu_agendamento_rapido.fff67526.png";